import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { get, post } from '@utils/axios_api';
import { AuthHook } from '@hooks';
import { qk } from "@utils/queryKey";

export function useLectureDetail(lectureId) {
  const { auth, isLoading } = AuthHook();
  const queryClient = useQueryClient();
  

  const { data:detail, isLoading:isDetailLoading } = useQuery({
    queryKey: qk.detail(lectureId),
    queryFn: () => get('/lecture/detail', { params: { lectureId } }),
    enabled: !!lectureId,                      
  });

  const { data:statusRes } = useQuery({
    queryKey: qk.applyStatus(lectureId),
    queryFn: () => get('/lecture/applyStatus', { params: { lectureId } }),
    enabled : !!lectureId && !isLoading && auth.isAuthenticated,
  });


  const cancelMut = useMutation({
    mutationFn: () => post('/lecture/applyCancel', { lectureId }),
    onSuccess: ({ message }) => {
      alert(message);

      queryClient.invalidateQueries({ queryKey: qk.lectureUser(lectureId) });
      // queryClient.invalidateQueries({ queryKey: qk.applyStatus(lectureId) });
      // queryClient.invalidateQueries({ queryKey: qk.applyModal(lectureId) });
    },
    onError: (error) => alert(error.message || '취소 중 오류가 발생했습니다.'),
  });

  const handleCancelApply = () => {
    if (!window.confirm('교육 신청을 취소하시겠습니까?')) return;
    cancelMut.mutate();
  };

  const applyStatus = statusRes?.applyStatus ?? null;

  return {
    lecture:   detail?.lecture,
    schedule:  detail?.schedule,
    loading:   isDetailLoading,
    applyStatus,
    isPending:  applyStatus === 'A',
    isApproved: applyStatus === 'B',
    isReapply:  ['C','N','R'].includes(applyStatus || ''),
    isManaged: applyStatus === 'M',
    handleCancelApply,
    refetchStatus: () => queryClient.invalidateQueries({ queryKey: qk.lectureUser(lectureId) }),
  };
}
